import React from "react";
export const Prmanage = (props) => {
  const { fill = "#8B8EA5" } = props;
  return (
    <svg
      width="24"
      height="24"
      viewBox="-2 -3 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 18C1.45 18 0.979333 17.8043 0.588 17.413C0.196 17.021 0 16.55 0 16V0L1.675 1.675L3.325 0L5 1.675L6.675 0L8.325 1.675L10 0L11.675 1.675L13.325 0L15 1.675L16.675 0L18.325 1.675L20 0V16C20 16.55 19.8043 17.021 19.413 17.413C19.021 17.8043 18.55 18 18 18H2ZM2 16H9V10H2V16ZM11 16H18V14H11V16ZM11 12H18V10H11V12ZM2 8H18V5H2V8Z"
        fill={fill}
      />
    </svg>
  );
};
export const Arrowsvg = ({ rotate = "90deg" }) => {
  return (
    <div
      style={{
        transform: `rotate(${rotate})`,
      }}
    >
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.99984 6.5L8.58984 7.91L13.1698 12.5L8.58984 17.09L9.99984 18.5L15.9998 12.5L9.99984 6.5Z"
          fill="#091E42"
        />
      </svg>
    </div>
  );
};
export const Dashboardsvg = (props) => {
  const { fill = "#8B8EA5" } = props;
  return (
    <svg
      width="24"
      height="24"
      viewBox="2 2 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 9V3H21V9H13ZM3 13V3H11V13H3ZM13 21V11H21V21H13ZM3 21V15H11V21H3Z"
        fill={fill}
      />
    </svg>
  );
};
export const Affiliatesvg = (props) => {
  const { fill = "#8B8EA5" } = props;
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0002 6.0001H14.0002L17.2902 2.7001C17.3832 2.60637 17.4938 2.53197 17.6156 2.4812C17.7375 2.43044 17.8682 2.4043 18.0002 2.4043C18.1322 2.4043 18.2629 2.43044 18.3848 2.4812C18.5067 2.53197 18.6173 2.60637 18.7102 2.7001L21.2902 5.2901C21.4765 5.47746 21.581 5.73091 21.581 5.9951C21.581 6.25928 21.4765 6.51273 21.2902 6.7001L19.0002 9.0001H11.0002V11.0001C11.0002 11.2653 10.8949 11.5197 10.7073 11.7072C10.5198 11.8947 10.2654 12.0001 10.0002 12.0001C9.73501 12.0001 9.48066 11.8947 9.29312 11.7072C9.10558 11.5197 9.00023 11.2653 9.00023 11.0001V8.0001C9.00023 7.46966 9.21094 6.96095 9.58601 6.58588C9.96109 6.21081 10.4698 6.0001 11.0002 6.0001ZM5.00023 11.0001V15.0001L2.71023 17.2901C2.52398 17.4775 2.41943 17.7309 2.41943 17.9951C2.41943 18.2593 2.52398 18.5127 2.71023 18.7001L5.29023 21.2901C5.38319 21.3838 5.49379 21.4582 5.61565 21.509C5.73751 21.5598 5.86821 21.5859 6.00023 21.5859C6.13224 21.5859 6.26294 21.5598 6.3848 21.509C6.50666 21.4582 6.61726 21.3838 6.71023 21.2901L11.0002 17.0001H15.0002C15.2654 17.0001 15.5198 16.8947 15.7073 16.7072C15.8949 16.5197 16.0002 16.2653 16.0002 16.0001V15.0001H17.0002C17.2654 15.0001 17.5198 14.8947 17.7073 14.7072C17.8949 14.5197 18.0002 14.2653 18.0002 14.0001V13.0001H19.0002C19.2654 13.0001 19.5198 12.8947 19.7073 12.7072C19.8949 12.5197 20.0002 12.2653 20.0002 12.0001V11.0001H13.0002V12.0001C13.0002 12.5305 12.7895 13.0392 12.4144 13.4143C12.0394 13.7894 11.5307 14.0001 11.0002 14.0001H9.00023C8.46979 14.0001 7.96109 13.7894 7.58601 13.4143C7.21094 13.0392 7.00023 12.5305 7.00023 12.0001V9.0001L5.00023 11.0001Z"
        fill={fill}
      />
    </svg>
  );
};
export const Companysvg = (props) => {
  const { fill = "#8B8EA5" } = props;
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 15H16V17H18M18 11H16V13H18M20 19H12V17H14V15H12V13H14V11H12V9H20M10 7H8V5H10M10 11H8V9H10M10 15H8V13H10M10 19H8V17H10M6 7H4V5H6M6 11H4V9H6M6 15H4V13H6M6 19H4V17H6M12 7V3H2V21H22V7H12Z"
        fill={fill}
      />
    </svg>
  );
};
export const Newsroomsvg = (props) => {
  const { fill = "#8B8EA5" } = props;
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 17H11V15H6V17ZM16 17H18V15H16V17ZM6 13H11V11H6V13ZM16 13H18V7H16V13ZM6 9H11V7H6V9ZM4 21C3.45 21 2.97933 20.8043 2.588 20.413C2.196 20.021 2 19.55 2 19V5C2 4.45 2.196 3.979 2.588 3.587C2.97933 3.19567 3.45 3 4 3H20C20.55 3 21.021 3.19567 21.413 3.587C21.8043 3.979 22 4.45 22 5V19C22 19.55 21.8043 20.021 21.413 20.413C21.021 20.8043 20.55 21 20 21H4Z"
        fill={fill}
      />
    </svg>
  );
};
export const Conatactussvg = (props) => {
  const { fill = "#8B8EA5" } = props;
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1385_13291)">
        <path
          d="M16.8302 20.0764L13.1054 17.5933C12.9388 17.4834 12.7156 17.5196 12.5924 17.6766L11.5078 19.0709C11.1563 19.5289 10.522 19.6597 10.018 19.3779L9.81751 19.2678C9.0941 18.8731 8.19349 18.3822 6.4057 16.5945C4.61791 14.8068 4.12656 13.9062 3.73228 13.1824L3.62178 12.9819C3.34004 12.4781 3.47079 11.8439 3.92882 11.4926L5.32276 10.4077C5.47997 10.2845 5.51623 10.0613 5.40603 9.89466L2.92323 6.16968C2.81031 6.00065 2.58468 5.9498 2.41016 6.05404L0.851671 6.98854C0.51731 7.18368 0.271396 7.50059 0.165381 7.87292C-0.346477 9.73681 0.0841 13.0005 5.04137 17.9579C9.99863 22.9154 13.2617 23.3468 15.1272 22.8345C15.4997 22.7284 15.8165 22.4823 16.0116 22.1478L16.9458 20.5894C17.0503 20.415 16.9994 20.1893 16.8302 20.0764Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.7732 1.00001C23.8335 0.999348 23.8916 1.02266 23.9342 1.06467C23.9769 1.10668 24.0006 1.16387 23.9999 1.22329V13.7816C23.9981 13.9034 23.8968 14.0009 23.7732 14H6.50034C6.49998 13.7562 6.49989 13.2745 6.4998 12.7869C6.4997 12.2748 6.49961 11.7562 6.49919 11.5L7.29004 10.6182C7.79391 10.2295 7.6062 9.1064 7.25292 8.58073L6.27345 7.13377V1.22329C6.27278 1.16387 6.29645 1.10668 6.3391 1.06467C6.38176 1.02266 6.43983 0.999348 6.50016 1.00001H23.7732ZM8.81786 3.83723C9.08653 3.46606 9.60942 3.38378 9.97596 3.6771L15.1584 7.8142L20.3428 3.67683C20.7098 3.38393 21.2325 3.46735 21.5003 3.83882C21.7576 4.19575 21.6972 4.70483 21.3461 4.98513L16.0955 9.17481C15.828 9.38535 15.4991 9.50102 15.1584 9.49994C14.8177 9.50102 14.4888 9.38536 14.2212 9.17481L14.2185 9.1727L8.96983 4.98445C8.61902 4.70327 8.55982 4.19382 8.81786 3.83723ZM15.1584 9.49994L15.1608 9.49993H15.156L15.1584 9.49994Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_1385_13291">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Gallerysvg = (props) => {
  const { fill = "#8B8EA5" } = props;
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 19C2.45 19 1.97933 18.8043 1.588 18.413C1.196 18.021 1 17.55 1 17V7C1 6.45 1.196 5.97933 1.588 5.588C1.97933 5.196 2.45 5 3 5H13C13.55 5 14.021 5.196 14.413 5.588C14.8043 5.97933 15 6.45 15 7V17C15 17.55 14.8043 18.021 14.413 18.413C14.021 18.8043 13.55 19 13 19H3ZM18 11C17.7167 11 17.4793 10.904 17.288 10.712C17.096 10.5207 17 10.2833 17 10V6C17 5.71667 17.096 5.479 17.288 5.287C17.4793 5.09567 17.7167 5 18 5H22C22.2833 5 22.5207 5.09567 22.712 5.287C22.904 5.479 23 5.71667 23 6V10C23 10.2833 22.904 10.5207 22.712 10.712C22.5207 10.904 22.2833 11 22 11H18ZM4 15H12L9.375 11.5L7.5 14L6.125 12.175L4 15ZM18 19C17.7167 19 17.4793 18.904 17.288 18.712C17.096 18.5207 17 18.2833 17 18V14C17 13.7167 17.096 13.479 17.288 13.287C17.4793 13.0957 17.7167 13 18 13H22C22.2833 13 22.5207 13.0957 22.712 13.287C22.904 13.479 23 13.7167 23 14V18C23 18.2833 22.904 18.5207 22.712 18.712C22.5207 18.904 22.2833 19 22 19H18Z"
        fill={fill}
      />
    </svg>
  );
};
export const PaymentHistorysvg = (props) => {
  const { fill = "#8B8EA5" } = props;
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 16H18C18.2833 16 18.5207 15.904 18.712 15.712C18.904 15.5207 19 15.2833 19 15V9C19 8.71667 18.904 8.479 18.712 8.287C18.5207 8.09567 18.2833 8 18 8H15C14.7167 8 14.4793 8.09567 14.288 8.287C14.096 8.479 14 8.71667 14 9V15C14 15.2833 14.096 15.5207 14.288 15.712C14.4793 15.904 14.7167 16 15 16ZM16 14V10H17V14H16ZM9 16H12C12.2833 16 12.521 15.904 12.713 15.712C12.9043 15.5207 13 15.2833 13 15V9C13 8.71667 12.9043 8.479 12.713 8.287C12.521 8.09567 12.2833 8 12 8H9C8.71667 8 8.47933 8.09567 8.288 8.287C8.096 8.479 8 8.71667 8 9V15C8 15.2833 8.096 15.5207 8.288 15.712C8.47933 15.904 8.71667 16 9 16ZM10 14V10H11V14H10ZM6 16C6.28333 16 6.521 15.904 6.713 15.712C6.90433 15.5207 7 15.2833 7 15V9C7 8.71667 6.90433 8.479 6.713 8.287C6.521 8.09567 6.28333 8 6 8C5.71667 8 5.479 8.09567 5.287 8.287C5.09567 8.479 5 8.71667 5 9V15C5 15.2833 5.09567 15.5207 5.287 15.712C5.479 15.904 5.71667 16 6 16ZM4 20C3.45 20 2.97933 19.8043 2.588 19.413C2.196 19.021 2 18.55 2 18V6C2 5.45 2.196 4.97933 2.588 4.588C2.97933 4.196 3.45 4 4 4H20C20.55 4 21.021 4.196 21.413 4.588C21.8043 4.97933 22 5.45 22 6V18C22 18.55 21.8043 19.021 21.413 19.413C21.021 19.8043 20.55 20 20 20H4Z"
        fill={fill}
      />
    </svg>
  );
};
export const Pricingsvg = (props) => {
  const { fill = "#8B8EA5" } = props;
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1 19H12.85V17.75C13.6833 17.6 14.4 17.275 15 16.775C15.6 16.275 15.9 15.5333 15.9 14.55C15.9 13.85 15.7 13.2083 15.3 12.625C14.9 12.0417 14.1 11.5333 12.9 11.1C11.9 10.7667 11.2083 10.475 10.825 10.225C10.4417 9.975 10.25 9.63333 10.25 9.2C10.25 8.76667 10.4043 8.425 10.713 8.175C11.021 7.925 11.4667 7.8 12.05 7.8C12.5833 7.8 13 7.92933 13.3 8.188C13.6 8.446 13.8167 8.76667 13.95 9.15L15.55 8.5C15.3667 7.91667 15.0293 7.40833 14.538 6.975C14.046 6.54167 13.5 6.3 12.9 6.25V5H11.15V6.25C10.3167 6.43333 9.66667 6.8 9.2 7.35C8.73333 7.9 8.5 8.51667 8.5 9.2C8.5 9.98333 8.72933 10.6167 9.188 11.1C9.646 11.5833 10.3667 12 11.35 12.35C12.4 12.7333 13.1293 13.075 13.538 13.375C13.946 13.675 14.15 14.0667 14.15 14.55C14.15 15.1 13.954 15.504 13.562 15.762C13.1707 16.0207 12.7 16.15 12.15 16.15C11.6 16.15 11.1127 15.979 10.688 15.637C10.2627 15.2957 9.95 14.7833 9.75 14.1L8.1 14.75C8.33333 15.55 8.696 16.196 9.188 16.688C9.67933 17.1793 10.3167 17.5167 11.1 17.7V19ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6873 5.825 19.975 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26267 14.6833 2 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31267 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.31233 8.1 2.787C9.31667 2.26233 10.6167 2 12 2C13.3833 2 14.6833 2.26233 15.9 2.787C17.1167 3.31233 18.175 4.025 19.075 4.925C19.975 5.825 20.6873 6.88333 21.212 8.1C21.7373 9.31667 22 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6873 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6873 15.9 21.212C14.6833 21.7373 13.3833 22 12 22Z"
        fill={fill}
      />
    </svg>
  );
};
export const Supportsvg = (props) => {
  const { fill = "#8B8EA5" } = props;
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 21V19H19V11.9C19 10.9333 18.8167 10.025 18.45 9.175C18.0833 8.325 17.5833 7.58333 16.95 6.95C16.3167 6.31667 15.575 5.81667 14.725 5.45C13.875 5.08333 12.9667 4.9 12 4.9C11.0333 4.9 10.125 5.08333 9.275 5.45C8.425 5.81667 7.68333 6.31667 7.05 6.95C6.41667 7.58333 5.91667 8.325 5.55 9.175C5.18333 10.025 5 10.9333 5 11.9V18H4C3.45 18 2.97933 17.8043 2.588 17.413C2.196 17.021 2 16.55 2 16V14C2 13.6167 2.09167 13.279 2.275 12.987C2.45833 12.6957 2.7 12.4583 3 12.275L3.075 10.95C3.225 9.73333 3.571 8.63333 4.113 7.65C4.65433 6.66667 5.32933 5.83333 6.138 5.15C6.946 4.46667 7.85433 3.93733 8.863 3.562C9.871 3.18733 10.9167 3 12 3C13.1 3 14.1543 3.18733 15.163 3.562C16.171 3.93733 17.075 4.47067 17.875 5.162C18.675 5.854 19.346 6.68733 19.888 7.662C20.4293 8.63733 20.775 9.725 20.925 10.925L21 12.225C21.3 12.375 21.5417 12.5957 21.725 12.887C21.9083 13.179 22 13.5 22 13.85V16.15C22 16.5167 21.9083 16.8417 21.725 17.125C21.5417 17.4083 21.3 17.625 21 17.775V19C21 19.55 20.8043 20.021 20.413 20.413C20.021 20.8043 19.55 21 19 21H11ZM9 14C8.71667 14 8.47933 13.904 8.288 13.712C8.096 13.5207 8 13.2833 8 13C8 12.7167 8.096 12.479 8.288 12.287C8.47933 12.0957 8.71667 12 9 12C9.28333 12 9.521 12.0957 9.713 12.287C9.90433 12.479 10 12.7167 10 13C10 13.2833 9.90433 13.5207 9.713 13.712C9.521 13.904 9.28333 14 9 14ZM15 14C14.7167 14 14.4793 13.904 14.288 13.712C14.096 13.5207 14 13.2833 14 13C14 12.7167 14.096 12.479 14.288 12.287C14.4793 12.0957 14.7167 12 15 12C15.2833 12 15.521 12.0957 15.713 12.287C15.9043 12.479 16 12.7167 16 13C16 13.2833 15.9043 13.5207 15.713 13.712C15.521 13.904 15.2833 14 15 14ZM6.025 12.45C5.95833 11.4667 6.096 10.575 6.438 9.775C6.77933 8.975 7.23733 8.29567 7.812 7.737C8.38733 7.179 9.05 6.75 9.8 6.45C10.55 6.15 11.3 6 12.05 6C13.5667 6 14.8793 6.47933 15.988 7.438C17.096 8.396 17.7667 9.59167 18 11.025C16.4333 11.0083 15.0167 10.5873 13.75 9.762C12.4833 8.93733 11.525 7.86667 10.875 6.55C10.6083 7.9 10.046 9.09567 9.188 10.137C8.32933 11.179 7.275 11.95 6.025 12.45Z"
        fill={fill}
      />
    </svg>
  );
};
